import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/admin/layout/Layout'
import LayoutSidebarless from '../views/admin/layout/LayoutSidebarless'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  { path: '/forgot', component: () => import('@/views/forgot/index'), hidden: true },
  { path: '/response/:email', component: () => import('@/views/forgot/response'), hidden: true },
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/token', component: () => import('@/views/external/token'), hidden: true },
  { path: '/reset', component: () => import('@/views/forgot/reset'), hidden: true },
  { path: '/success', component: () => import('@/views/forgot/success'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '', component: () => import('@/views/home/index'), hidden: true },
  { path: '/settings', component: () => import('@/views/home/settings'), hidden: true },
  { path: '/legal', component: () => import('@/views/legal/legal'), hidden: true },
  { path: '/privacy', component: () => import('@/views/legal/privacy'), hidden: true },
  { path: '/cookie', component: () => import('@/views/legal/cookie'), hidden: true },
  { path: '/unconfirmed', component: () => import('@/views/unconfirmed/index'), hidden: true },

  // Archive Versions
  // v1
  { path: '/v/v1/login', component: () => import('@/views/home/v1/index'), hidden: true },
]

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
  mode: 'history'
})

export const unconfirmedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/index'), hidden: true }
]

export const rejectedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/rejected'), hidden: true }
]

export const asyncRouterMap = [
  {
    path: '/z/:branchId/moim/overview',
    component: Layout,
    redirect: '',
    name: 'MOIM',
    meta: { feature: 'moim', title: 'Overview' },
    children: [
      {
        path: '',
        component: () => import('@/views/moim/overview'),
        meta: { title: 'MOIM' }
      }
    ],
    hidden: true,
    branch: true
  },
  // {
  //   path: '/z/:branchId/notification',
  //   component: Layout,
  //   redirect: 'notification',
  //   name: 'Notification',
  //   meta: { title: 'Notification', icon: 'ow_clock1' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/notification/index'),
  //       meta: { title: 'Notification', icon: 'ow_clock1', badge: 'notification' }
  //     }
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/moim/mobile_app',
    component: Layout,
    redirect: '',
    name: 'Home',
    meta: { moimModule: 'mobile_app', feature: 'moim', title: 'Home' },
    children: [
      {
        path: '',
        component: () => import('@/views/moim/mobile_app/home'),
        meta: { title: 'Home' }
      },
    ],
    alwaysShow: true,
    branch: true,
    hidden: true
  },
  {
    path: '/z/:branchId/moim/mobile_app/inbound',
    component: Layout,
    redirect: '',
    name: 'Inbound',
    meta: { moimModule: 'mobile_app', feature: 'moim', title: 'Inbound' },
    children: [
      {
        path: '',
        component: () => import('@/views/moim/mobile_app/recievingrawmaterialscanlogs'),
        meta: { title: '01 Inbound Logs' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/moim/mobile_app/usage',
    component: Layout,
    redirect: '',
    name: 'Usage',
    meta: { moimModule: 'mobile_app', feature: 'moim', title: 'Usage' },
    children: [
      {
        path: '',
        component: () => import('@/views/moim/mobile_app/usageproductscanlogs'),
        meta: { title: '02 Usage Logs' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/moim/mobile_app/transfer',
    component: Layout,
    redirect: '',
    name: 'Transfer',
    meta: { moimModule: 'mobile_app', feature: 'moim', title: 'Transfer' },
    children: [
      {
        path: '',
        component: () => import('@/views/moim/mobile_app/transferproductscanlogs'),
        meta: { title: '03 Transfer Logs' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/moim/mobile_app/maintenance',
    component: Layout,
    redirect: '',
    name: 'Maintenance',
    meta: { moimModule: 'mobile_app', feature: 'moim', title: 'Maintenance' },
    children: [
      {
        path: '',
        component: () => import('@/views/moim/mobile_app/maintenanceproductscanlogs'),
        meta: { title: '04 Maintenance Logs' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/moim/mobile_app/available',
    component: Layout,
    redirect: '',
    name: 'Available',
    meta: { moimModule: 'mobile_app', feature: 'moim', title: 'Available' },
    children: [
      {
        path: '',
        component: () => import('@/views/moim/mobile_app/availableproductscanlogs'),
        meta: { title: '05 Available Logs' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/moim/web_app',
    component: Layout,
    redirect: '',
    name: 'Reporting',
    meta: { moimModule: 'web_app', feature: 'moim', title: 'Reporting', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/moim/dashboard'),
        meta: { title: 'Dashboard', icon: 'ow_clock1' }
      },
      {
        path: 'reporting',
        component: () => import('@/views/moim/reporting'),
        meta: { title: 'Reporting', relationRoles: ['admin', 'supervisor'], icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/moim/web_app/register',
    component: Layout,
    redirect: '',
    name: 'Register',
    meta: { moimModule: 'web_app', feature: 'moim', relationRoles: ['admin', 'supervisor'], title: 'Register', icon: 'ow_clock1' },
    children: [
      {
        path: 'clients',
        component: () => import('@/views/moim/clients'),
        meta: { title: 'Clients', icon: 'ow_clock1' }
      },
      {
        path: 'categories',
        component: () => import('@/views/moim/categories'),
        meta: { title: 'Categories', icon: 'ow_clock1' }
      },
      {
        path: 'locations',
        component: () => import('@/views/moim/locations'),
        meta: { title: 'Locations', icon: 'ow_clock1' }
      },
      {
        path: 'products',
        component: () => import('@/views/moim/products'),
        meta: { title: 'Products', icon: 'ow_clock1' }
      },
      {
        path: 'crewstaffs',
        component: () => import('@/views/moim/crewstaffs'),
        meta: { title: 'Crew Staffs', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/moim/web_app/register_leader',
    component: Layout,
    redirect: '',
    name: 'Register',
    meta: { moimModule: 'web_app', feature: 'moim', relationRoles: ['leader'], title: 'Register', icon: 'ow_clock1' },
    children: [
      {
        path: 'crewstaffs',
        component: () => import('@/views/moim/crewstaffs'),
        meta: { title: 'Crew Staffs', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/moim/web_app/warehouse',
    component: Layout,
    redirect: '',
    name: 'Warehouse',
    meta: { moimModule: 'web_app', feature: 'moim', title: 'Warehouse', icon: 'ow_clock1' },
    children: [
      {
        path: 'inboundqrcodes',
        component: () => import('@/views/moim/inboundqrcodes'),
        meta: { title: '01 Product QRCode', icon: 'ow_clock1' }
      },
      {
        path: 'inboundscan',
        component: () => import('@/views/moim/inboundscan'),
        meta: { title: '02 Inbound Scan Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'usagescan',
        component: () => import('@/views/moim/usagescan'),
        meta: { title: '03 Usage Scan Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'transferscan',
        component: () => import('@/views/moim/transferscan'),
        meta: { title: '04 Transfer Scan Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'maintenancescan',
        component: () => import('@/views/moim/maintenancescan'),
        meta: { title: '05 Maintenance Scan Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'availablescan',
        component: () => import('@/views/moim/availablescan'),
        meta: { title: '06 Available Scan Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'productstocks',
        component: () => import('@/views/moim/productstocks'),
        meta: { title: '07 Product Stocks', icon: 'ow_clock1' }
      },
      {
        path: 'productstockupdatelogs',
        component: () => import('@/views/moim/productstockupdatelogs'),
        meta: { title: '08 Transaction Logs', icon: 'ow_clock1' }
      },
      {
        path: 'packedproducts',
        component: () => import('@/views/moim/packedproducts'),
        meta: { title: '09 Individual Products', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/moim/web_app/user',
    component: Layout,
    redirect: '',
    name: 'Users',
    meta: { moimModule: 'web_app', feature: 'moim', relationRoles: ['admin', 'supervisor'], title: 'User', icon: 'ow_clock1' },
    children: [
      {
        path: 'registerstaff',
        component: () => import('@/views/moim/registerstaff'),
        meta: { title: 'Registered Users', icon: 'ow_clock1' }
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/moim/manual',
    component: Layout,
    redirect: '',
    name: 'User Manual',
    meta: { moimModule: 'web_app', feature: 'moim', title: 'User Manual', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/moim/pdfmanual'),
        meta: { title: 'User Manual', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },

  // default - has branch
  // {
  //   path: '/z/:branchId/branch',
  //   component: Layout,
  //   redirect: 'profile',
  //   name: 'Co. Settings',
  //   meta: { title: 'Co. Settings', icon: 'ow_clock1' },
  //   children: [
  //     {
  //       path: 'profile',
  //       component: () => import('@/views/settings/branch/profile'),
  //       meta: { title: 'Profile', icon: 'ow_clock1' }
  //     },
  //     {
  //       path: 'email',
  //       component: () => import('@/views/settings/branch/email'),
  //       meta: { title: 'Email', icon: 'ow_clock1' }
  //     },
  //     {
  //       path: 'collaborator',
  //       component: () => import('@/views/settings/branch/collaborator'),
  //       meta: { title: 'Collaborator', icon: 'ow_clock1' }
  //     }
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/account',
  //   component: Layout,
  //   redirect: 'profile',
  //   name: 'User Settings',
  //   meta: { title: 'User Settings', icon: 'ow_clock1' },
  //   children: [
  //     {
  //       path: 'profile',
  //       component: () => import('@/views/settings/user/profile'),
  //       meta: { title: 'Profile', icon: 'ow_clock1' }
  //     },
  //     {
  //       path: 'password',
  //       component: () => import('@/views/settings/user/password'),
  //       meta: { title: 'Password', icon: 'ow_clock1' }
  //     }
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/branches',
  //   component: Layout,
  //   redirect: 'branches',
  //   name: 'Branches',
  //   meta: { title: 'Branches' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/admin/companies/index'),
  //       meta: { title: 'Branches', icon: 'ow_clock1' }
  //     }
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/default',
    component: Layout,
    redirect: '',
    name: 'Default',
    meta: { title: 'Default' },
    children: [
      {
        path: '',
        component: () => import('@/views/admin/default/index'),
        meta: { title: 'Default', icon: 'ow_clock1' }
      }
    ],
    hidden: true,
    branch: true
  },

  // default - no branch
  {
    path: '/branch',
    component: Layout,
    redirect: 'profile',
    name: 'Co. Settings',
    meta: { title: 'Co. Settings', icon: 'ow_clock1' },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/settings/branch/profile'),
        meta: { title: 'Profile', icon: 'ow_clock1' }
      },
      {
        path: 'email',
        component: () => import('@/views/settings/branch/email'),
        meta: { title: 'Email', icon: 'ow_clock1' }
      },
      {
        path: 'collaborator',
        component: () => import('@/views/settings/branch/collaborator'),
        meta: { title: 'Collaborator', icon: 'ow_clock1' }
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: 'profile',
    name: 'User Settings',
    meta: { title: 'User Settings', icon: 'ow_clock1' },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/settings/user/profile'),
        meta: { title: 'Profile', icon: 'ow_clock1' }
      },
      {
        path: 'password',
        component: () => import('@/views/settings/user/password'),
        meta: { title: 'Password', icon: 'ow_clock1' }
      }
    ]
  },
  // {
  //   path: '/email',
  //   component: Layout,
  //   redirect: 'email',
  //   name: 'Email',
  //   meta: { title: 'Email', icon: 'ow_clock1' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/email/index'),
  //       meta: { title: 'Email', icon: 'ow_clock1' }
  //     }
  //   ],
  //   branch: false
  // },
  // {
  //   path: '/branches',
  //   component: Layout,
  //   redirect: 'branches',
  //   name: 'Branches',
  //   meta: { title: 'Branches' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/admin/companies/index'),
  //       meta: { title: 'Branches', icon: 'ow_clock1' }
  //     }
  //   ],
  //   branch: false
  // },
  // {
  //   path: '/dashboard',
  //   component: Layout,
  //   redirect: 'dashboard',
  //   name: 'Dashboard',
  //   meta: { title: 'Dashboard' },
  //   children: [{
  //     path: '',
  //     component: () => import('@/views/admin/dashboard/index'),
  //     meta: { title: 'Dashboard', icon: 'el-icon-monitor' }
  //   },
  //   {
  //     path: 'instance',
  //     component: () => import('@/views/admin/dashboard/index'),
  //     name: 'New Instance',
  //     meta: { title: 'New Instance' },
  //     hidden: true
  //   }]
  // },
  {
    path: '/users',
    component: Layout,
    redirect: 'users',
    name: 'Users',
    meta: { roles: ['generalmanager'], title: 'Users' },
    children: [{
      path: '',
      component: () => import('@/views/admin/users/index'),
      meta: { title: 'Users', icon: 'ow_clock1' }
    }]
  }
  // { path: '*', redirect: '/404', hidden: true }
]



// WEBPACK FOOTER //
// ./src/router/index.js